export default class {
  execute(properties, component) {
    const t = TrelloPowerUp.iframe()
    t.showCard(properties.cardId)
  }
}
